/**
 * Permissions for encounter actions in care-admin.
 *
 * Checking a patient out closes the open encounter AND files its claim
 * (legacy.php?checkout -> User::saveClaims), so it both ends care and creates
 * a payable. It had no permission of its own: the server had no check at all,
 * and this UI borrowed `checkins.update` / `checkins.close` — "may edit a
 * check-in" should never have implied "may file a claim".
 *
 * This list mirrors LegacyAdminActionGate::ACTION_CHECKOUT_ENCOUNTER exactly,
 * so the button is shown when and only when the endpoint would accept the
 * call. The coarser lifecycle permissions are accepted alongside the specific
 * one so nobody loses the action before 20260921_encounters_checkout_permission
 * backfills encounters.checkout onto their role.
 */
export const ENCOUNTER_CHECKOUT_PERMISSIONS = [
  'encounters.checkout',
  'encounters.discharge',
  'encounters.manage',
  'checkins.manage',
  'admin.*',
];

/** Legacy staff role ids that could check out before permissions existed. */
export const LEGACY_CHECKOUT_ROLES = [1, 3];

/**
 * Filing an encounter's claim — care-admin's "Compose Claim Request" screen,
 * which posts to legacy.php?claimLog.
 *
 * Mirrors LegacyAdminActionGate::ACTION_FILE_ENCOUNTER_CLAIM. ?claimLog and
 * ?checkout are two legacy keys onto one function (User::saveClaims), so this
 * list overlaps the checkout one; it is wider because the same endpoint also
 * serves opening a PA, which is what this screen does.
 *
 * preauth.create matters here: medical_officer and customer_service hold it
 * and nothing else on the list, and filing is a core part of their job.
 */
export const ENCOUNTER_FILE_CLAIM_PERMISSIONS = [
  'encounters.checkout',
  'encounters.discharge',
  'encounters.manage',
  'checkins.manage',
  'checkins.close',
  'claims.create',
  'preauth.create',
  'admin.*',
];

/** Legacy staff role ids that could file before permissions existed. */
export const LEGACY_FILE_CLAIM_ROLES = [1, 2];

/**
 * Changing an encounter's check-in type (In-Patient, Out-Patient,
 * Telemedicine, ...). Mirrors AdminCheckins::changeTypePermissions: admins
 * keep it, and encounters.change_type lets RBAC give it to Customer Service
 * and others without full admin.
 */
export const ENCOUNTER_CHANGE_TYPE_PERMISSIONS = [
  'encounters.change_type',
  'admin.*',
  'platform.*',
  'platform.operator',
];
